import slick from 'slick-carousel';

function ensureSlick() {
  if (typeof $.fn.slick === 'function') {
    return true;
  }

  if (typeof slick === 'function') {
    slick(window, window.jQuery || $);
  }

  return typeof $.fn.slick === 'function';
}

export default (el) => {
  if (!ensureSlick()) {
    return;
  }

  const $component = $(el),
        $slider = $component.find('.testimonial-slider-block-slider'),
        $controls = $component.find('.testimonial-slider-block-controls');

  // Initialize Slick slider
  $slider.slick({
    dots: true,
    arrows: true,
    appendDots: $controls,
    appendArrows: $controls,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          adaptiveHeight: false
        }
      }
    ]
  });
};
